import { Row } from 'app/design/primitives/box';
import { PCImage } from 'app/design/primitives/image';
import { Text } from 'app/design/primitives/text';
import { useNavigation } from 'app/hooks/navigation';
import { localeAwareFormatDistance } from 'app/lib/date';
import { navigateToUserProfile } from 'app/screens/billboard/navigator-helper';
import type { Request } from 'app/types/listing';
import { type TFunction } from 'i18next';
import React from 'react';
import { Pressable } from 'react-native';

interface LenderAcceptedLoanProps {
  lender: Request['lender'];
  t: TFunction;
  scale?: number;
  style?: React.ComponentProps<typeof Row>['style'];
}

function LenderAcceptedLoan({ lender, t, style, scale = 1 }: LenderAcceptedLoanProps) {
  const navigation = useNavigation();
  if (!lender) {
    return null;
  }

  const imageSource = lender.picture ? { uri: lender.picture } : undefined;

  const spacing = scale >= 0.7 ? 'spacing.general.x2' : 'spacing.general.x1';
  const innerGap = 'spacing.general.x0,5';

  return (
    <Pressable onPress={() => navigateToUserProfile(navigation, lender.id)} style={style}>
      <Row
        alignItems="center"
        gap={spacing}
        backgroundColor="surface.success.subtle"
        padding={spacing}
        paddingHorizontal="spacing.general.x4"
        borderRadius="radius.lg"
      >
        <PCImage
          height={35 * scale}
          width={35 * scale}
          source={imageSource}
          style={{ borderRadius: 17.5 * scale }}
          useOwnCache
        />
        <Row flex={1} minWidth={0} gap={innerGap} paddingRight={innerGap} flexWrap="wrap">
          <Text
            variant="bodyBase"
            fontWeight="bold"
            fontSize={13 * scale}
            numberOfLines={1}
            ellipsizeMode="tail"
            color="text.success"
          >
            {lender.name}
          </Text>
          <Text variant="bodyBase" fontSize={13 * scale} color="text.secondary">
            {t('hasAcceptedLoanAgo', {
              ns: 'one-listing',
              ago: localeAwareFormatDistance(new Date(), new Date(lender.acceptedAt)),
            })}
          </Text>
        </Row>
      </Row>
    </Pressable>
  );
}

export default LenderAcceptedLoan;
